import React, { useRef } from 'react';
import { Box, Grid, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider, Button, Stack } from '@mui/material';
import image from "../../../asserts/LALogistic-1.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from 'react-router';
import moment from 'moment';
import { useDispatch } from "react-redux";
import { fetchAndOpenDocketPdf } from "../../../redux/Thunk/docketThunk"
import DocketPDF from '../../../components/Custom/DocketpdfMake';

const DocketFormate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const pickup = state?.docketData?.pickupDetails;
  const customer = state?.docketData?.pickupDetails?.customer?.[0];
  const pkg = pickup?.PackageDetails[0];
  const docketRef = useRef();

  // const handleDownloadClick = () => {
  //   docketRef.current?.generatePDF(); // Call method from child
  // };
  const handleDownloadClick = () => {
    console.log("DocketId:", state?.docketData?.DocketId)
    dispatch(fetchAndOpenDocketPdf(state?.docketData?.DocketId));
  };

  console.log(pkg, state?.docketData, 'pkg')
  return (
    <>
      <Paper sx={{ p: 2, m: 2 }}>
        <Box className="custom-data-grid-container_table">
          {/* Back Button */}
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} style={{ margin: '5px 10px' }}>
            <Stack direction={"row"} alignItems={"center"} gap={2}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', fontSize: '24px', fontWeight: 600, cursor: 'pointer', mb: 1 }} onClick={() => navigate("/dashboard/docketlist")}><ArrowBackIcon /> Docket Label</Typography>
            </Stack>

            <Stack direction={'row'} spacing={1} justifyContent={"flex-end"} alignItems={'center'}>
              <Button sx={{ justifyContent: 'flex-end' }} variant="contained" color="success" onClick={handleDownloadClick}>Download PDF</Button>
            </Stack>  </Stack>
          {/* Header: Logo + Barcode + Service Info */}
          <Grid container spacing={2} style={{ padding: '0px 10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
              <img src={image} width={140} alt="Logo" />
              {/* <Typography variant="body2">1234567896</Typography>
            <Typography variant="body2">xyz@gmail.com</Typography> */}
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
              <Box >
                <Typography variant="body2" fontWeight="bold" marginBottom='5px' fontSize={20} color='Red'>LA Logistic</Typography>
                <Typography fontSize={14}>
                  Alisha Vrundavan, Flat No. B-406
                  Opp. Indian Oil Petrol Pump
                  Chikhali Road, Pune - 411062<br />
                  Mob: 8956433858<br />
                  Email: customercare@lalogistic.in<br />
                  GST No.: 27AMYPG4098G1ZE
                </Typography>
              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
              <Table size="small" sx={{ border: '1px solid black', borderCollapse: 'collapse', mt: 1 }}>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ border: '1px solid black', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>SERVICE</TableCell>
                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', justifyContent: 'center', alignItems: 'center' }}>DOCKET NUMBER</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ border: '1px solid black', justifyContent: 'center', alignItems: 'center' }}>SURFACE</TableCell>
                    <TableCell sx={{ border: '1px solid black', justifyContent: 'center', alignItems: 'center' }}>{state?.docketData?.DocketId}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', justifyContent: 'center', alignItems: 'center' }}>ORIGIN</TableCell>
                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', justifyContent: 'center', alignItems: 'center' }}>DESTINATION</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ border: '1px solid black', justifyContent: 'center', alignItems: 'center' }}>{pickup?.Origin}</TableCell>
                    <TableCell sx={{ border: '1px solid black', justifyContent: 'center', alignItems: 'center' }}>{pickup?.Destination}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
          </Grid>

          <Divider sx={{ my: 1 }} />

          {/* Address Section */}
          <Grid container spacing={2} style={{ padding: '0px 10px' }}>
            <Grid size={{ xs: 6, sm: 12, md: 6, lg: 6 }}>
              {/* <Box sx={{ border: '2px solid #000', p:0.2, pl:0.5}}>
              <Typography fontWeight="bold">SHIPPER A/C : </Typography>
            </Box> */}
              <Box sx={{ border: '2px solid #000', px: 1, p: 0.2 }}>
                <Typography><strong>Date:</strong> {moment(pickup?.PickupDateAndTime).format("DD-MMM-YYYY")}</Typography>
              </Box>
              <Box sx={{ border: '2px solid #000', px: 1, p: 0.2 }}>
                <Typography><strong>Customer Name:</strong> {customer?.CustomerName}</Typography>
              </Box>
              <Box sx={{ border: '1px solid #000', p: 1, mt: 1 }}>
                <Typography fontWeight="bold" color='red' fontSize={20}>Consignor</Typography>
                <Typography><strong>Sender Name : </strong>{pickup?.Consignee} </Typography>
                <Typography><strong>Mobile : </strong> {pickup?.SenderMobile}</Typography>
              </Box>
            </Grid>

            {/* Date & Docket No. */}
            <Grid size={{ xs: 6, sm: 12, md: 6, lg: 6 }}>
              {/* <Box sx={{ border: '2px solid #000', px: 1, p:0.2 }}>
               <Typography><strong>Date:</strong> {moment(pickup?.PickupDateAndTime).format("DD-MMM-YYYY")}</Typography>
              </Box> */}
              {/* <Box sx={{ border: '2px solid #000', px: 1 }}>
                <Typography><strong>ONFD NO:</strong> __________________</Typography>
              </Box> */}

              <Box sx={{ border: '1px solid #000', p: 1, mt: 4.5 }}>
                <Typography fontWeight="bold" color='red' fontSize={20}>Consignee</Typography>
                <Typography> <strong>Reciever Name : </strong>{pickup?.Consigner}</Typography>
                <Typography> <strong>Mobile : </strong>{pickup?.ReceiverMobile}</Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 6, sm: 12, md: 6, lg: 6 }}>
              {/* <Box sx={{ border: '2px solid #000', p:0.2, pl:0.5}}>
              <Typography fontWeight="bold">SHIPPER A/C : </Typography>
            </Box> */}
              <Box sx={{ border: '1px solid #000', p: 1, mt: 1 }}>
                <Typography fontWeight="bold" color='red' fontSize={20}>Pickup Address</Typography>
                <Typography marginBottom={'50px'}>{pickup?.PickupAddress}</Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 6, sm: 12, md: 6, lg: 6 }}>
              {/* <Box sx={{ border: '2px solid #000', p:0.2, pl:0.5}}>
              <Typography fontWeight="bold">SHIPPER A/C : </Typography>
            </Box> */}
              <Box sx={{ border: '1px solid #000', p: 1, mt: 1 }}>
                <Typography fontWeight="bold" color='red' fontSize={20}>Destination Address</Typography>
                <Typography marginBottom={'50px'}>{pickup?.DestinationAddress}</Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Packing Info Table */}
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small" sx={{ border: '1px solid #000', }}>
              <TableHead>
                <TableRow >
                  <TableCell sx={{ fontWeight: 'Bold' }}>No. of PCS</TableCell>
                  <TableCell sx={{ fontWeight: 'Bold' }}>Packing</TableCell>
                  <TableCell sx={{ fontWeight: 'Bold' }}>CONTENTS (SAID TO CONTAIN)</TableCell>
                  <TableCell sx={{ fontWeight: 'Bold' }}>DIM (cm) L*W*H</TableCell>
                  <TableCell sx={{ fontWeight: 'Bold' }}>INVOICE NO</TableCell>
                  <TableCell sx={{ fontWeight: 'Bold' }}>INVOICE VALUE</TableCell>
                  <TableCell sx={{ fontWeight: 'Bold' }}>ACTUAL WEIGHT</TableCell>
                  <TableCell sx={{ fontWeight: 'Bold' }}>Special Remarks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pickup?.PackageDetails?.length > 0 ? (
  // Step 1: Group packages by L*W*H
  Object.values(
    pickup.PackageDetails.reduce((acc, pkg) => {
      const key = `${pkg?.length}x${pkg?.breadth}x${pkg?.height}`;
      if (!acc[key]) {
        acc[key] = { 
          count: 0, 
          ...pkg 
        };
      }
      acc[key].count += 1;
      return acc;
    }, {})
  ).map((group, index) => (
    <TableRow key={index}>
      <TableCell>{group.count}</TableCell>
      <TableCell>{group?.BoxType}</TableCell>
      <TableCell>{pickup?.Content}</TableCell>
      <TableCell>{`${group?.length} * ${group?.breadth} * ${group?.height}`}</TableCell>
      <TableCell>---</TableCell>
      <TableCell>---</TableCell>
      <TableCell>{group?.Volumetrix}</TableCell>
      <TableCell>{pickup?.Remark || "No remarks"}</TableCell>
    </TableRow>
  ))
) : (
  <TableRow>
    <TableCell>1</TableCell>
    <TableCell>---</TableCell>
    <TableCell>{pickup?.Content}</TableCell>
    <TableCell>---</TableCell>
    <TableCell>---</TableCell>
    <TableCell>---</TableCell>
    <TableCell>---</TableCell>
    <TableCell>{pickup?.Remark || "No package details"}</TableCell>
  </TableRow>
)}

              </TableBody>

            </Table>
          </TableContainer>

          {/* Signature Section */}
          <Grid container spacing={1} style={{ padding: '0px 10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
              <Box sx={{ border: '1px solid #000', pl: 4, pr: 4, pb: 4, mt: 0.5 }}>
                <Typography align="left" sx={{ fontSize: '10px', textDecoration: 'underline' }}><strong>TERM & CONDITION</strong></Typography>
              </Box>

              <Box sx={{ border: '1px solid #000', p: 1, mt: 1 }}>
                <Typography sx={{ fontSize: '12px' }}><strong>SENDER'S NAME:</strong> - - - - - - - - - - - -</Typography>
                <Typography sx={{ fontSize: '12px' }}><strong>SIGNATURE:</strong> - - - - - - - - - - - </Typography>
              </Box>

            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
              <Box sx={{ border: '1px solid #000', pl: 6, pr: 6, pb: 11, mt: 0.5 }}>
                <Typography align='left' sx={{ fontSize: '12px', textDecoration: 'underline' }}><strong>CONDITION & LIABILITY</strong></Typography>
                <Typography></Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
              <Box sx={{ border: '1px solid #000', p: 1, mt: 0.5 }}>
                <Typography sx={{ fontSize: '15px' }}><strong>RECEIVED BY </strong></Typography>
                <Typography sx={{ fontSize: '14px' }}>SIGNATURE:_______________________</Typography>
                <Typography sx={{ fontSize: '14px' }}>DATE: ___________ TIME: ___________</Typography>
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 0.5 }} />

          {/* Footer Note */}
          <Grid container spacing={1} style={{ padding: '0px 10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 2 }}></Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '12px' }}>
                ALL DISPUTES ARE SUBJECT TO BHIWANDI JURISDICTION
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 2 }}><Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>CUSTOMER COPY</Typography></Grid>
          </Grid>
        </Box>
      </Paper>
      {/* <DocketPDF ref={docketRef} state={state?.docketData} /> */}
    </>
  );
};

export default DocketFormate;
